interface RadioProps {
  label: string;
  name: any;
  value: any;
  id: string;
  checked: any;
  className?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function Radio({
  label,
  name,
  value,
  id,
  checked,
  className,
  onChange,
}: RadioProps) {
  return (
    <div className="w-auto flex mr-5 text-grey font-thin justify-start items-center">
      <label className="text-md mr-2">{label}:</label>
      <input
        name={name}
        value={value}
        id={id}
        checked={checked}
        onChange={onChange}
        type="radio"
        className={`border rounded-md p-2 mt-1 cursor-pointer ${className}`}
      />
    </div>
  );
}
